import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { palette } from '../styles/theme';

export const InputField = ({
    label,
    value,
    placeholder,
    onChange,
    multiline = false,
    width = '100%',
    error,
    maxLength,
    showCharacterCount = false
}) => (
    <Box display='flex' flexDirection='column' gap='8px' width={width} >
        <Typography variant='body1'>{label}</Typography>
        <TextField
            value={value}
            onChange={(e) => {
                const newValue = e.target.value;
                if (maxLength && newValue.length > maxLength) {
                    return;
                }
                onChange(newValue);
            }}
            onBlur={(e) => {
                let cleanedValue = e.target.value;

                if (multiline) {
                    cleanedValue = cleanedValue
                        .split('\n')
                        .map(line => line.trimEnd())
                        .join('\n')
                        .trim();
                }
                else {
                    cleanedValue = cleanedValue
                        .replace(/\s+/g, ' ')
                        .trim();
                }

                onChange(cleanedValue);
            }}
            error={error}
            variant="outlined"
            placeholder={placeholder}
            fullWidth
            multiline={multiline}
            rows={multiline ? 11 : 1}
            sx={{
                '& .MuiInputBase-root': {
                    borderRadius: '8px',
                    padding: '0px',
                },
                '& .MuiOutlinedInput-input': {
                    height: !multiline ? '20px' : 'auto',
                    padding: '6px 16px',
                },
                '&:hover fieldset': {
                    borderColor: `${palette.icons} !important`,
                },
            }}
        />
        {showCharacterCount && maxLength && (
            <Typography
                variant='caption'
                sx={{
                    color: palette.disabled.main,
                    textAlign: 'right',
                    fontSize: '12px'
                }}
            >
                {value?.length || 0}/{maxLength}
            </Typography>
        )}
    </Box>
);
